/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tab-bar.vue?vue&type=template&id=7fb2d843&scoped=true&"
import script from "./tab-bar.vue?vue&type=script&lang=js&"
export * from "./tab-bar.vue?vue&type=script&lang=js&"
import style0 from "./tab-bar.vue?vue&type=style&index=0&id=7fb2d843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2d843",
  null
  
)

export default component.exports